<template>
  <table :style="styles" cellspacing="0" cellpadding="0" border="0">
    <colgroup v-if="!isGroupColumn">
      <col v-for="(column, index) in columns" :key="index" :width="setCellWidth(column, index, true)"/>
    </colgroup>
    <colgroup v-else>
      <col v-for="(column, index) in leafColumns" :key="index" :width="setCellWidth(column, index, true)"/>
    </colgroup>
    <thead v-if="!isGroupColumn" ref="thead">
      <tr>
        <th v-for="(column, index) in columns" :colspan="column.col" :rowspan="column.row" :key="index" :class="alignClasses(column)" @mouseenter.stop="isEllipsis($event,index)">
          <div :class="$_cellClasses(column, index)">
            <template v-if="column.type === 'expand'"></template>
            <template v-else-if="column.type === 'selection'">
              <t-checkbox
                :indeterminate="indeterminate"
                v-model="isSelectAll"
                label="">
              </t-checkbox>
            </template>
            <template v-else>
              <template v-if="columnHeadDiagonal && $_isDiagonalColumn(column) && column.title">
                <t-tooltip
                  v-for="n in (columnHeadDiagonal+1)"
                  :key="n"
                  :max-width="350"
                  :class="diagonalClasses(n)"
                  :content="column.title[n-1]"
                  :disabled="!diagonalColumn[n-1]._isEllipsis"
                  @mouseenter.native.stop="isEllipsis($event,n-1)"
                >
                <div :class="$_cellTextClasses(column)" >
                  <span :class="[prefixTableClass + '__cell--text']">
                    <div :class="[prefixTableClass + '__cell--text--inner', 'text-truncate']" v-html="renderHeader(column, index, n)"></div>
                  </span>
                </div>
                </t-tooltip>
              </template>
              <!-- :disabled="(column._isEllipsis === false) && (allEllipsis === false)" -->
              <template v-else>
                <t-tooltip
                  v-if="column.title"
                  :content="column.title"
                  :max-width="350"
                  :disabled="(column._isEllipsis === false)"
                  @mouseenter.native.stop="isEllipsis($event, index)">
                  <div :class="$_cellTextClasses(column)" >
                  <span :class="[prefixTableClass + '__cell--text']">
                    <!-- ================================================= -->
                    <template v-if="column.renderHeader">
                      <t-expand
                        v-if="column.renderHeader"
                        :row="data[index]"
                        :column="column"
                        :index="index"
                        :render="column.renderHeader"></t-expand>
                    </template>
                    <template v-else>
                      <span v-html="column.title"></span>
                    </template>
                    <!-- ================================================= -->
                  </span>
                  </div>
                </t-tooltip>
              </template>
            </template>
          </div>
          <span v-if="column.sortable && !isTableTree" :class="[prefixTableClass + '-sort']" @click="$_onSortIconClick(index)">
            <i :class="{on: column.sortType === 'asc'}" class="aid aid-menu-up"></i>
            <i :class="{on: column.sortType === 'desc'}" class="aid aid-menu-down"></i>
          </span>
          <Poptip
            v-if="isPopperShow(column)"
            v-model="column._filterVisible"
            placement="bottom"
            @on-popper-hide="$_onPoptipPopperHide(index)">
            <span :class="[prefixTableClass + '-filter']">
              <i :class="{on: column._isFiltered}" class="aid aid-filter"></i>
            </span>
            <div v-if="column._filterMultiple"
                 slot="content"
                 :class="[prefixTableClass + '-filter-list']"
                 style="left:initial!important">
              <div :class="[prefixTableClass + '-filter-list-item']">
                <checkbox-group v-model="column._filterChecked" vertical>
                  <checkbox v-for="(item, index) in column.filters" :key="index" :label="item.value">{{ item.label }}</checkbox>
                </checkbox-group>
              </div>
              <div :class="[prefixTableClass + '-filter-footer']">
                <t-button :disabled="!column._filterChecked.length" size="sm" @click.native="$_onFilterButtonClick(index)">{{ t('t.table.confirmFilter') }}</t-button>
                <t-button size="sm" @click.native="$_onResetButtonClick(index)">{{ t('t.table.resetFilter') }}</t-button>
              </div>
            </div>
            <div v-else slot="content" :class="[prefixTableClass + '-filter-list']">
              <ul :class="[prefixTableClass + '-filter-list-single']">
                <li :class="[
                      prefixTableClass + '-filter-select-item',
                      {
                        [ prefixTableClass + '-filter-select-item-selected' ]: !column._filterChecked.length
                      }
                    ]"
                    @click="$_onClearFilterItemClick(index)">{{ t('t.table.clearFilter') }}
                </li>
                <li v-for="(item, idx) in column.filters"
                    :class="[
                      prefixTableClass + '-filter-select-item',
                      {
                        [prefixTableClass + '-filter-select-item-selected']: column._filterChecked[ 0 ] === item.value
                      }
                    ]"
                    :key="idx"
                    @click="$_onFilterListItemClick(index, item.value)">{{ item.label }}
                </li>
              </ul>
            </div>
          </Poptip>
          <template v-if="columnHeadDiagonal && $_isDiagonalColumn(column)">
            <div v-for="i in columnHeadDiagonal"
                 :key="i"
                 class="diagonal__line"></div>
          </template>
        </th>
      </tr>
    </thead>
    <thead v-else>
      <tr v-for="(columns, rowIndex) in columnRows" :key="rowIndex">
        <th v-for="(column, cellIndex) in columns" :key="column.columnId"
            :colspan="column.colSpan"
            :rowspan="column.rowSpan">
          <div :class="$_cellClasses(column, cellIndex)">
            <template v-if="columnHeadDiagonal && $_isDiagonalColumn(column) && column.title">
              <t-tooltip
                v-for="n in (columnHeadDiagonal+1)"
                :key="n"
                :max-width="350"
                :class="diagonalClasses(n)"
                :content="column.title[n-1]"
                :disabled="!diagonalColumn[n-1]._isEllipsis"
                @mouseenter.native.stop="isEllipsis($event,n-1)"
              >
              <div :class="$_cellTextClasses(column)" >
                <span :class="[prefixTableClass + '__cell--text']">
                  <div :class="[prefixTableClass + '__cell--text--inner', 'text-truncate']" v-html="renderHeader(column, cellIndex, n)"></div>
                </span>
              </div>
              </t-tooltip>
            </template>
            <!-- :disabled="(column._isEllipsis === false) && (allEllipsis === false)" -->
            <template v-else>
              <t-tooltip
                v-if="column.title"
                :content="column.title"
                :max-width="350"
                :disabled="(column._isEllipsis === false)"
                @mouseenter.native.stop="isEllipsis($event, cellIndex)">
                <div :class="$_cellTextClasses(column)" >
                <span :class="[prefixTableClass + '__cell--text']">
                  <div :class="[prefixTableClass + '__cell--text--inner', 'text-truncate']" v-html="column.title"></div>
                </span>
                </div>
              </t-tooltip>
            </template>
          </div>
        </th>
      </tr>
    </thead>
  </table>
</template>
<script>
import CheckboxGroup from '../checkbox/checkbox-group.vue'
import Checkbox from '../checkbox/checkbox.vue'
import Poptip from '../poptip/poptip.vue'
import iButton from '../button/button.vue'
import Mixin from './mixin'
import Locale from '../../mixins/locale'
import TExpand from './expand'

export default {
  name: 'TTableHead',
  components: {
    CheckboxGroup,
    Checkbox,
    Poptip,
    iButton,
    TExpand
  },
  mixins: [ Mixin, Locale ],
  props: {
    prefixTableClass: String,
    styleObject: Object,
    columns: Array,
    selectStatus: String,
    data: Array, // rebuildData
    columnsWidth: Object,
    isTableTree: Boolean,
    fixed: {
      type: [ Boolean, String ],
      default: false
    },
    columnHeadDiagonal: Number,
    allEllipsis: Boolean,
    wordBreak: Boolean
  },
  data () {
    return {
      type: 'normal',
      diagonalColumn: [
        {_isEllipsis: false},
        {_isEllipsis: false},
        {_isEllipsis: false}
      ],
      timerResize: null
    }
  },
  computed: {
    styles () {
      const style = Object.assign({}, this.styleObject)
      const width = this.$parent.bodyHeight === 0 ? parseInt(this.styleObject.width) : parseInt(this.styleObject.width) + this.$parent.scrollBarWidth
      style.width = `${width}px`
      return style
    },
    isSelectAll: {
      get () {
        return this.selectStatus === 'all'
      },
      set (newValue) {
        this.$parent.selectAll(newValue)
      }
    },
    indeterminate () {
      return this.selectStatus === 'indeterminate'
    },
    originColumns () {
      return this.columns
    },
    columnRows () {
      return this.$_convertToRows(this.originColumns)
    },
    leafColumns () {
      let allColumn = this.$_getAllColumns(this.originColumns)
      const leafColumns = this.$_getLeafColumns(allColumn)
      this.$parent.groupColumn = leafColumns
      return leafColumns
    },
    isGroupColumn() { // 是否多级表头
      const isGroup = this.columnRows.length > 1
      this.$parent.isGroup = isGroup
      return isGroup
    }
  },
  watch: {
    columns: {
      handler (newValue, oldValue) {
        this.$_resize()
      },
      deep: true
    }
  },

  mounted () {
    this.$_resize()
    window.addEventListener('resize', this.$_resize, false)
  },
  beforeDestroy() {
    if (this.timerResize !== null) {
      clearTimeout(this.timerResize)
    }
    window.removeEventListener('resize', this.$_resize, false)
  },
  methods: {
    $_cellClasses (column, index) {
      return [
        `${this.prefixTableClass}__cell`,
        {
          // [`${this.prefixTableClass}--hidden`]: !this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right'),
          // [`${this.prefixTableClass}__cell--ellipsis`]: true,
          [`diagonal__cell `]: this.columnHeadDiagonal && this.$_isDiagonalColumn(column)
        }
      ]
    },
    $_cellTextClasses(column) {
      return [
        `${this.prefixTableClass}-cell__text-content`,
        {
          [`${this.prefixTableClass}__cell--ellipsis`]:true
        }
      ]
    },
    diagonalClasses (index) {
      return [
        {
          [`bottom-l`]: index === 1,
          [`top-l`]: this.columnHeadDiagonal === 2 && index === 2,
          [`top-r`]: (this.columnHeadDiagonal === 2 && index === 3) || (this.columnHeadDiagonal === 1 && index === 2)
        }
      ]
    },
    $_itemClasses (column, item) {
      return [
        `${this.prefixTableClass}-filter-select-item`,
        {
          [`${this.prefixTableClass}-filter-select-item-selected`]: column._filterChecked[ 0 ] === item.value
        }
      ]
    },
    $_itemAllClasses (column) {
      return [
        `${this.prefixTableClass}-filter-select-item`,
        {
          [`${this.prefixTableClass}-filter-select-item-selected`]: !column._filterChecked.length
        }
      ]
    },
    renderHeader (column, $index, textIndex) {
      if ('renderHeader' in this.columns[ $index ]) {
        return this.columns[ $index ].renderHeader(column, $index)
      } else {
        if (column.title) {
          if (Array.isArray(column.title)) {
            return column.title[textIndex - 1]
          } else {
            return column.title
          }
        } else {
          return '#'
        }
      }
    },
    $_onSortIconClick (index) {
      switch (this.type) {
        case 'normal':
          this.type = 'asc'
          break
        case 'asc':
          this.type = 'desc'
          break
        case 'desc':
          this.type = 'normal'
          break
      }
      this.$parent.sort(index, this.type)
    },
    $_onFilterButtonClick (index) {
      this.$parent.handleFilter(index)
    },
    $_onFilterListItemClick (index, value) {
      this.$parent.filterSelect(index, value)
    },
    $_onResetButtonClick(index) {
      this.filterReset(index)
    },
    $_onClearFilterItemClick(index) {
      this.filterReset(index)
    },
    filterReset (index) {
      this.$parent.filterReset(index)
    },
    $_onPoptipPopperHide (index) {
      this.$parent.filterHide(index)
    },
    isEllipsis (event, index) {
      const $target1 = event.currentTarget
      const $targetParent = $target1.querySelector('.table__cell--ellipsis')
      if ($target1.nodeName === 'TH') {
        let $target = $target1.querySelector('.table__cell--ellipsis .table__cell--text .table__cell--text--inner')
        if (!$target) {
          $target = $target1.querySelector('.table__cell--ellipsis .table__cell--text')
        }
        if ($target && $targetParent.scrollWidth > $targetParent.offsetWidth) { // 判断是否有文字缩略
          this.$set(this.columns[index], '_isEllipsis', true)
        } else {
          this.$set(this.columns[index], '_isEllipsis', false)
        }
      } else {
        let $target = $target1.querySelector('.table__cell--text--inner')
        if (!$target) {
          $target = $target1.querySelector('.table__cell--text')
        }
        if(!$targetParent){
          const $targetParent = $target1
        }
        if ($target && $target1.scrollWidth > $target1.offsetWidth && this.diagonalColumn[index]) {
          this.$set(this.diagonalColumn[index], '_isEllipsis', true)
        }
        if (!this.diagonalColumn) {
          if ($target && $target1.offsetWidth < $target1.scrollWidth) { // 判断是否有文字缩略
            this.$set(this.columns[index], '_isEllipsis', true)
          } else {
            this.$set(this.columns[index], '_isEllipsis', false)
          }
        }
      }
    },
    $_isDiagonalColumn (column) {
      return column && column.title && Array.isArray(column.title)
    },
    $_drawDiagonalLine () {
      let target = this.$refs.thead.querySelector('.diagonal__line')
      const ref = target.parentNode
      let coordinate = this.getCoordinate(ref)
      let width = 0
      const bl = ref.querySelector('.bottom-l')
      const rel = bl.querySelector('.table__cell--text--inner')
      if (this.columnHeadDiagonal === 1) {
        width = parseInt((coordinate.x2 - coordinate.x1) / 2)
        this.createLine(coordinate.x1, coordinate.y1, coordinate.x2, coordinate.y2, target)
      } else if (this.columnHeadDiagonal === 2) {
        width = parseInt((coordinate.x2 - coordinate.x1) / 3)
        target = this.$refs.thead.querySelectorAll('.diagonal__line')
        this.createLine(0, coordinate.y2 / 2.5, coordinate.x2, coordinate.y2, target[0])
        this.createLine(coordinate.x2 / 2.5, 0, coordinate.x2, coordinate.y2, target[1])
        const tl = ref.querySelector('.top-l')
        tl.style.left = parseInt(coordinate.x1 + (width / 2)) + 'px'
        tl.style.width = width + 'px'
        tl.style.top = coordinate.x1 + 'px'
      }
      bl.style.left = coordinate.x1 + 'px'
      bl.style.width = width + 'px'
      bl.style.top = coordinate.y2 - coordinate.y1 - rel.offsetHeight - 5 + 'px'
      const tr = ref.querySelector('.top-r')
      if (this.fixed) {
        tr.style.right = '5px'
      } else {
        const trRel = tr.querySelector('.table__cell--text--inner')
        tr.style.left = coordinate.x2 - trRel.offsetWidth - 5 + 'px'
      }
      tr.style.width = width + 'px'
      tr.style.top = coordinate.x1 + 'px'
    },
    $_resize () {
      if (this.timerResize !== null) {
        clearTimeout(this.timerResize)
      }
      this.timerResize = setTimeout(() => {
        if (this.columnHeadDiagonal) {
          this.$nextTick(this.$_drawDiagonalLine())
        }
      }, 300)
    },
    $_convertToRows (originColumns) {
      let maxLevel = 1
      const traverse = (column, parent) => {
        if (parent) {
          column.level = parent.level + 1
          if (maxLevel < column.level) {
            maxLevel = column.level
          }
        }
        if (column.children) {
          let colSpan = 0
          column.children.forEach((subColumn) => {
            traverse(subColumn, column)
            colSpan += subColumn.colSpan
          })
          column.colSpan = colSpan
        } else {
          column.colSpan = 1
        }
      }

      originColumns.forEach((column) => {
        column.level = 1
        traverse(column)
      })

      const rows = []
      for (let i = 0; i < maxLevel; i++) {
        rows.push([])
      }

      const allColumns = this.$_getAllColumns(originColumns)
      allColumns.forEach((column) => {
        if (!column.children) {
          column.rowSpan = maxLevel - column.level + 1
        } else {
          column.rowSpan = 1
        }
        rows[column.level - 1].push(column)
      })

      return rows
    },
    $_getAllColumns (columns) {
      const result = []
      columns.forEach((column) => {
        if (column.children) {
          result.push(column)
          result.push.apply(result, this.$_getAllColumns(column.children))
        } else {
          result.push(column)
        }
      })
      return result
    },
    $_getLeafColumns (columns) {
      const result = []
      columns.forEach((column) => {
        if (!column.children) {
          result.push(column)
        }
      })
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// table-head.vue?a252706e